import { i18nMark } from 'lingui-react';

const messages = {
  complaint: i18nMark('Complaint'),
};

export default messages;



// WEBPACK FOOTER //
// ./components/WizardSteps/ReasonForRepair/messages.js